<template>
  <!-- select 2 demo -->
  <div>
    <b-modal
      ref="origin-breakdown-info-modal"
      hide-footer
      hide-header
      scrollable
      @hidden="hiddenModal"
      size="md"
    >
     <div class="model-close-container">
      <button class="close-modal-btn" @click="hiddenModal()"><CloseModalIcon /></button>
     </div>
     <div class="info-modal-container cs-scroll-style" :style="{ 'max-height': $store.state.appConfig.bodyHeight + 'px' }">
        <div class="info-modal-header">
          <h5>{{$tI('Genetic Distance Maps Title')}}</h5>
        </div>
        <p class="description" v-html="$tI_G('Genetic Distance Maps explanation')"></p>
     </div>
     <div class="model-info-bottom">
      <div></div>
      <button class="info-modal-btn single-btn" @click="hiddenModal()">Got it</button>
     </div>
    </b-modal>
  </div>
</template>

<script>
import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';
import CloseModalIcon from '@/components/icons/CloseModalIcon.vue';
export default {
  components: {
    CloseModalIcon,
  },
  props: {
    modalObject: {
      type: Object,
    },
    callback: {
      type: Function,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      sampleInfo: null,
    }
  },
  methods: {
    initialModal() {
      communicationService.sendTriggerToParent({ key: dataKeys.MODAL_STATUS, value: true });
      this.$refs['origin-breakdown-info-modal'].show();
    },
    hiddenModal() {
      /* eslint-disable */
      this.modalObject.showModal = false;
      this.$refs['origin-breakdown-info-modal'].hide();
      communicationService.sendTriggerToParent({ key: dataKeys.MODAL_STATUS, value: false });
    },
  },
  computed: {
  },
  mounted() {
    this.initialModal()
  },
};
</script>

<style lang="scss" scoped>

</style>
